const CLIENT_ID_STORAGE_NAME = 'clientId';

export function getClientId(): string {
    const storedClientId = localStorage.getItem(CLIENT_ID_STORAGE_NAME);

    if (storedClientId) {
        return storedClientId;
    }

    const newClientId = generateClientId();
    localStorage.setItem(CLIENT_ID_STORAGE_NAME, newClientId);

    return newClientId;
}

function generateClientId(): string {
    // Generate a UUID v4
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
        const random = (Math.random() * 16) | 0;
        const value = char === 'x' ? random : (random & 0x3) | 0x8;

        return value.toString(16);
    });
}
